import { Grid, Box, Bones } from '@simplywallst/ui-core';
import { Tile } from '@/components/TileNew';

const TileSkeleton = () => (
  <Tile>
    <Tile.Header>
      <Box height="143px" overflow="hidden">
        <Bones />
        <Bones />
        <Bones />
        <Bones />
        <Bones />
        <Bones />
        <Bones />
        <Bones />
        <Bones />
      </Box>
    </Tile.Header>
    <Grid
      height="326px"
      paddingTop="x13"
      paddingLeft="x3"
      paddingRight="x3"
      templateColumns="auto 120px"
      gap="8px"
      alignItems="center"
    >
      <Box>
        <Bones margin="x1" />
        <Bones margin="x1" />
        <Bones margin="x1" />
      </Box>
      <Box>
        <Box
          borderRadius="x12"
          height="110px"
          width="110px"
          backgroundColor="white"
          opacity={0.1}
        />
      </Box>
    </Grid>
    <Tile.Footer>
      <Grid
        templateColumns="repeat(3, 16px) 60px 50px"
        gap="10px"
        alignItems="center"
        paddingBottom="x2"
        paddingLeft="x3"
      >
        <Bones borderRadius="x1" />
        <Bones borderRadius="x1" />
        <Bones borderRadius="x1" />
        <Bones />
        <Bones borderRadius="x2" />
      </Grid>
    </Tile.Footer>
  </Tile>
);
export const LoadingSkeleton = () => (
  <Box
    marginLeft="x2"
    marginRight="x2"
    marginTop="x3"
    marginLeftLg="x0"
    marginRightLg="x0"
  >
    <Grid
      gap="24px"
      templateColumnsMd="repeat(2, 1fr)"
      templateColumnsLg="repeat(3, 1fr)"
      width="100%"
      data-cy-id="tile-view"
    >
      <TileSkeleton />
      <TileSkeleton />
      <TileSkeleton />
    </Grid>
  </Box>
);
